import { SxProps, Theme } from "@mui/material";

export const linksItemWrapperStyles: SxProps<Theme> = {
    display: "grid",
    gridTemplateColumns: {
        xs: "repeat(2, 1fr)",
        md: "repeat(4, minmax(150px, 200px))",
    },
    justifyContent: "center",
    gap: 4,
    px: 4,
};
